import AnimationClip from '../AnimationClip';
import { Easing } from '@tweenjs/tween.js';
import ElementComponent from '../../../Component/UI/Element';
import GameObject from '../../../GameObject/GameObject';
import { MathHelper } from 'Utility/MathHelper';
interface FillBarMeta {
    progress: number;
    duration?: number;
    loop?: boolean;
}

export class FillBar extends AnimationClip<FillBarMeta> {
    public static setProgress(
        gameObject: GameObject,
        progress: number,
        cachedFillElem?: ElementComponent
    ) {
        if (gameObject.destroyed) return;

        const fillElem =
            cachedFillElem || gameObject.getComponent(ElementComponent);

        fillElem.scale.x = MathHelper.clamp(progress, 0, 1);
    }

    public *execute(
        gameObject: GameObject,
        meta: FillBarMeta
    ): IterableIterator<number> {
        const fillElem = gameObject.getComponent(ElementComponent);
        const prevProgress = fillElem.scale.x;

        const duration =
            meta.duration !== undefined
                ? meta.duration
                : (meta.progress - prevProgress) * 4000;

        const progressTween = this.getTween({ progress: prevProgress });
        progressTween
            .to({ progress: meta.progress }, duration)
            .easing(Easing.Linear.None)
            .onUpdate(t => {
                FillBar.setProgress(gameObject, t.progress, fillElem);
            });

        yield* this.startTween(progressTween);

        // TODO: check if this is necessary at all
        if (meta.loop) while (true) yield;
    }
}
